'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icons = require('./icons.css');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Solutions = function Solutions() {
  var ua = navigator.userAgent.toLowerCase();
  var safari = false;
  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      safari = false;
    } else {
      safari = true;
    }
  }

  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 374 604', className: _icons2.default.solutions },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_1_', gradientUnits: 'userSpaceOnUse', x1: '-768.327', y1: '842.3309', x2: '-768.9379', y2: '841.2768', gradientTransform: 'matrix(278 0 0 -278 213892 234395)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' }, stopOpacity: '1' }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' }, stopOpacity: '1' })
      )
    ),
    _react2.default.createElement('path', { style: { fill: safari ? '#F09420' : 'url(#SVGID_1_)' }, className: _icons2.default.solutions1, d: 'M187,556.5c-76.9,0-139.5-62.6-139.5-139.5S110.1,277.5,187,277.5c76.9,0,139.5,62.6,139.5,139.5 S263.9,556.5,187,556.5z M187,278.5c-76.4,0-138.5,62.1-138.5,138.5S110.6,555.5,187,555.5S325.5,493.4,325.5,417 S263.4,278.5,187,278.5z' }),
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_2_', gradientUnits: 'userSpaceOnUse', x1: '-761.9966', y1: '842.054', x2: '-764.0115', y2: '838.8141', gradientTransform: 'matrix(94 0 0 -94 71936 79375)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' }, stopOpacity: '1' }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' }, stopOpacity: '1' })
      )
    ),
    _react2.default.createElement('path', { style: { fill: safari ? '#F09420' : 'url(#SVGID_2_)' }, className: _icons2.default.solutions2, d: 'M187,464.5c-26.2,0-47.5-21.3-47.5-47.5s21.3-47.5,47.5-47.5s47.5,21.3,47.5,47.5S213.2,464.5,187,464.5z M187,370.5c-25.6,0-46.5,20.9-46.5,46.5s20.9,46.5,46.5,46.5c25.6,0,46.5-20.9,46.5-46.5S212.6,370.5,187,370.5z' }),
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_3_', gradientUnits: 'userSpaceOnUse', x1: '-762.7745', y1: '840.8061', x2: '-764.8032', y2: '837.5325', gradientTransform: 'matrix(94 0 0 -94 71936 79048)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' }, stopOpacity: '1' }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' }, stopOpacity: '1' })
      )
    ),
    _react2.default.createElement('path', { style: { fill: safari ? '#F09420' : 'url(#SVGID_3_)' }, className: _icons2.default.solutions3, d: 'M187,137.5c-26.2,0-47.5-21.3-47.5-47.5s21.3-47.5,47.5-47.5s47.5,21.3,47.5,47.5S213.2,137.5,187,137.5z M187,43.5c-25.6,0-46.5,20.9-46.5,46.5s20.9,46.5,46.5,46.5c25.6,0,46.5-20.9,46.5-46.5S212.6,43.5,187,43.5z' }),
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_4_', gradientUnits: 'userSpaceOnUse', x1: '-769.2339', y1: '842.3095', x2: '-769.6378', y2: '841.9057', gradientTransform: 'matrix(374 0 0 -604 287956 508935)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' }, stopOpacity: '1' }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' }, stopOpacity: '1' })
      )
    ),
    _react2.default.createElement('path', { style: { fill: safari ? '#F09420' : 'url(#SVGID_4_)' }, className: _icons2.default.solutions4, d: 'M334,605H40c-22.6,0-41-18.4-41-41V40C-1,17.4,17.4-1,40-1h294c22.6,0,41,18.4,41,41v524 C375,586.6,356.6,605,334,605z M40,1C18.5,1,1,18.5,1,40v524c0,21.5,17.5,39,39,39h294c21.5,0,39-17.5,39-39V40 c0-21.5-17.5-39-39-39H40z' })
  );
};

exports.default = Solutions;


//////////////////
// WEBPACK FOOTER
// ./src/components/Technical/Solutions.js
// module id = 338
// module chunks = 1